<script>
	import Counter from "./Counter.svelte";
	import { onMount } from "svelte";
	import { createEventDispatcher } from "svelte";

	import { each } from "svelte/internal";

	const dispatch = createEventDispatcher();

	export let counters; // pic is [{v:2},{v:0},{v:4},....]
	let counterssum = 0;
	const onValChangeHandler = (event) => {
		let oldctrsum = counterssum;
		counterssum += parseInt(event.detail.val);
		// notify interested that counters value was changed
		dispatch("chvalall", { val: counterssum - oldctrsum });
	};

	//init sum of all counters
	onMount(() => {
		counters.forEach((item) => {
			counterssum += parseInt(item.v);
		});
	});
</script>

<h2>{counterssum}</h2>
<div>
	{#each counters as cnts}
		<Counter val={cnts.v} on:chval={onValChangeHandler} />
	{/each}
</div>

<style>
	h2 {
		position: relative;
		width: 90%;
		border: 1px solid black;
		background-color: rgb(9, 11, 121);
		color: rgb(255, 255, 255);
		border-radius: 30px;
		padding: 6px;
		margin: auto;
		text-align: center;
		font-weight: bold;
		font-size: 22px;
	}

	div {
		width: 80%;
		padding: 12px;
		border-radius: 9px;
		border-bottom: 5px outset rgb(245, 142, 137);

		background-color: rgb(147, 220, 248);
		margin: auto;
		margin-bottom: 15px;
	}
</style>
